<template>
  <div class="animated fadeIn">
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else>
      <template slot="header">
        <i class='fa fa-align-justify'></i>
        <label for="crs_id" v-b-tooltip.hover title="Active - Active , Active - Standby operation by one policy. You can group and configure policies for a multiplexed configuration">Multiplexing (?)</label>
        <strong class="pull-right">{{manage.created_at | datetime}}</strong>
      </template>
      <b-button v-if="manage && manage.id" class="pull-right mr-2" size="sm" variant="danger" @click="remove_modal = true">Delete Policy</b-button>
      <b-tabs>
        <b-tab title="Policy">
          <template v-if="quick_setting_status" class="animated fadeIn fadeOut">
            <hr>
            <RuleQuickSetup
              v-if="default_rule && default_rule.rule"
              :rule_selected="sel_domain.rule"
              :domain="sel_domain.domain"
              :quick_setting="quick_setting"
              :ico="ico"
              :is_one="is_one"
              :crs_rule="default_rule.rule"
              :setting_level="setting.level"
              :setting_mode="setting.mode"
              :user="user"
              :is_first="is_first"

              @save_default="save_default"
              @status="() => { quick_setting_status = false; is_first = false }"
            >
            </RuleQuickSetup>
          </template>
          <b-card v-if="manage && !quick_setting_status">
            <b-row>
              <b-col md="8">
                <b-form-checkbox v-model="setting.status" v-on:change="status_save($event, setting.status)" name="check-button" switch>
                  WEBCastle Engine (global)
                  On / Off
                </b-form-checkbox>
              </b-col>
              <b-col md="4">
                <b-button class="pull-right" size="sm" variant="outline-primary" @click="quick_setting_status = true">Quick Setup Guide </b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card v-if="manage && !quick_setting_status">
            <b-row>
              <b-col md="2">
                <strong class="mb-2">Policy Name</strong>
              </b-col>
              <b-col md="10">
                <b-form-input size="m" placeholder="set name for management" v-model="manage.name"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col md="2">
                <strong class="mb-2">Virtual Domain </strong>
                <br>
                Usage : {{manage.count_domain}}
              </b-col>
              <b-col md="6">
                <b-form-select v-model="sel_domain.domain" @change="change_domain($event, sel_domain.id)" size="sm" style="width:100%;">
                  <option v-for="item in manage.policy_json.domains" :key="item.id" :value="item.domain">{{item.domain}}</option>
                </b-form-select>

              </b-col>
              <b-col md="4">
                <b-button style="max-width:150px; width:100%;" size="sm" class="m-2 float-right" variant="primary" @click="explain_user_crs = true">
                  Domain Manage
                </b-button>
              </b-col>
            </b-row>

            <hr>
            <b-row class="text-center">
              <b-col md="4" style="cursor: pointer;">
                <strong style="cursor: pointer;" @click="explain_level = true">Policy Security Level <span>(?)</span></strong>
                <b-form-radio-group style="cursor: pointer;" id="ph_level" v-model="setting.level" :options="codes.WAF_LEVEL"></b-form-radio-group>
              </b-col>
              <b-col md="4">
                <strong style="cursor: pointer;">Firewall Mode <span @click="explain_mode = true">(?)</span>  :
                  <b-badge v-if="setting.mode == 0" variant="secondary">Off</b-badge>
                  <b-badge v-if="setting.mode == 1" variant="warning">DetectionOnly</b-badge>
                  <b-badge v-if="setting.mode == 2" variant="danger">Block</b-badge>
                </strong>
                  <b-form-radio-group id="ph_mode" v-model="setting.mode" :options="codes.WAF_MODE_OPTION"> </b-form-radio-group>
              </b-col>
              <b-col md="3">
                <div class="pull-right">
                  <b-button size="sm" variant="success" @click="rule_confirm = true">Apply</b-button>
                </div>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-form-group>
                  <h5>
                    <b-badge variant="warning">Notice</b-badge>
                    <small> <strong> The policy security level defaults to 1 and higher levels may affect the service </strong></small><br>
                    <small> <strong> * Off : Disable WEBCastle function for the currently selected domain </strong></small><br>
                    <small> <strong> * DetectionOnly : Detect Only while on Activation </strong></small><br>
                    <small> <strong> * On : Block While On Activation </strong></small>
                  </h5>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <!-- 탭부분 시작 -->
          <b-tabs v-model="tabIndex" v-if="manage && !quick_setting_status">
            <!-- 방화벽 기본 정책 설정 -->
            <b-tab title="Policy (CRS)" @click="get(false)">
              <b-row>
                <b-col>
                  <strong>You can set firewall policies, only enable or disable</strong>
                  <!-- 1. Quick은 사용하는 서비스 선택, (기본 설정들 보여줌) -->
                  <!-- 2. allow ip 선택 -->
                </b-col>
              </b-row>
              <hr>
              <RuleService
                v-if="!quick_setting_status"
                :quick_setting="quick_setting"
                :ico="ico"
                @toggle_policy="toggle_policy"

              >  </RuleService>
              <hr v-if="!quick_setting_status" class="animated fadeIn fadeOut">
              <template v-if="!quick_setting_status" class="animated fadeIn fadeOut">
                <RuleSelector
                  class="animated fadeIn fadeOut"
                  ref="RuleSelector"

                  :rule_selected="sel_domain.rule"
                  :rule_data="rule_set.rule"
                  :rule_block="sel_domain.block"
                  :rule_detect="sel_domain.detect"
                  :mode="setting.mode"
                  :level="setting.level"

                  @policy_rule="policy_rule"
                  @quick_policy_one="(data) => quick_setting = Object.assign({}, quick_setting, data)"
                  @block_policy="(block) => sel_domain = Object.assign({}, sel_domain, { block : block })"
                  @detect_policy="(detect) => sel_domain = Object.assign({}, sel_domain, { detect : detect })"
                  @rule_sel="(x) => sel_domain = Object.assign({}, sel_domain, { rule : x })"
                  v-bind:toss_rule="save"
                  v-if="sel_domain"
                >
                </RuleSelector>
              </template>
            </b-tab>
            <!-- 방화벽 사용자 설정 -->
            <!-- custom 문법 체크가 필요함 -->
            <b-tab title="Custom Policy (Custom-CRS)">
              <b-row>
                <b-col>
                  <strong>
                    <b-badge variant="warning">Notice</b-badge> : Use only by experts.
                    <hr>
                    User Custom CRS Setting
                  </strong><br><br>
                  <span>Allows the user to customize the rule.</span><br>
                  <strong>Please specify the rule id 6000000-+ ID.</strong>
                  <!-- 커스텀 부분으로 룰 활성화 부분 안내 -->
                  <hr>
                  Rule 920350 about "Host Header is a numeric IP address"
                  <br>
                  If you want to redirect to http://f1security.co.kr when detect rule 920350
                  <br>
                  <br>
                  Example : SecRuleUpdateActionById 920350 "t:none,msg:'redirection from numeric IP',deny,redirect:'http://f1security.co.kr'"
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col>
                  <b-form-group>
                    <b-form-textarea id="ph_content" v-model="user.custom_rule" :max-rows="50"></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <!-- ip 관련 접근 제어 -->
            <b-tab title="IP Address">
              <RuleIP
                class="animated fadeIn fadeOut"
                @block_ip="($val, key) => user.block_ip = $val"
                @allow_ip="($val, key) => user.allow_ip = $val"
                :origin="{ allow_ip : user.allow_ip, block_ip: user.block_ip }"
                :is_setup="false"
                :setting="{ mode: manage.mode, level : setting.level }"
              ></RuleIP>
            </b-tab>
            <!-- path 관련 사용자 정책 설정 -->
            <b-tab title="Path">
              <!-- @update 에서 key 는 구분자임 -->
              <RuleCustom
                class="animated fadeIn fadeOut"
                :origin="user.path"
                name="path"
                :is_setup="false"
                example="/admin,/manager,/images"
                @update="($val, key) => user.path = $val"
              ></RuleCustom>
            </b-tab>
            <!-- 파라미터 관련 사용자 설정 -->
            <b-tab title="Parameter(Query String)">
              <!-- @update 에서 key 는 구분자임 -->
              <RuleCustom
                class="animated fadeIn fadeOut"
                :origin="user.parameter"
                name="params"
                example="id=test : Detects if query string has id=test,test : Detects if query string has test"
                :is_setup="false"
                @update="($val, key) => user.parameter = $val"
              ></RuleCustom>
            </b-tab>
          </b-tabs>
        </b-tab>
        <b-tab>
          <template #title>
            Agent List
            <b-badge variant="success">{{manage.count_agent}}</b-badge>
          </template>
          <b-button block size="sm" variant="success" @click="agent_confirm = true">Apply</b-button>
          <hr v-if="apply_all_server && apply_all_server.length">
          <b-badge variant="success" v-for="(item, index) in apply_all_server" :key="index" class="m-1">
            <h6 @click="multi_remove(index)" style="cursor:pointer;">{{item.nickname}} <span class="m-1" style="cursor:pointer;">X</span></h6>
          </b-badge>
          <hr>
          <AgentList :manage_id="manage.id" ref="_wc_agent_list" :list_selected="apply_all_server"  :only_select="true" @multi_clear="multi_clear" @multi_all="multi_all" @multi_one="multi_one" />
        </b-tab>
        <!-- 아직 로그는 베타 버전임 -->
        <b-tab title="Log">
          <Log v-if="apply_all_server.length" ref="_wc_log_list" :agent_id_list="apply_all_server"  :only_view="true" :auto_refresh="true" />
          <p class="text-center">
            No agents selected
          </p>
        </b-tab>
      </b-tabs>
    </b-card>
    <!-- for modal -->
    <b-modal title="Status Save?"  class="modal-warning" v-model="status_confirm" @ok="status_save" ok-variant="danger">
      <p>Turn off / turn on the firewall on that server.</p>
    </b-modal>
    <b-modal title="Do you want me to save the changes?"  class="modal-warning" v-model="rule_confirm" @ok="save" ok-variant="danger" header-bg-variant="danger">
      <b-form-input placeholder="What is name this policy ?"  class="m-1" v-model="manage.name"></b-form-input>
      <hr>
      <p>Save changed settings Incorrect rule settings may affect the service</p>
    </b-modal>
    <b-modal title="Do you want me to save the changes?"  class="modal-warning" v-model="agent_confirm" @ok="multi_save" ok-variant="danger" header-bg-variant="danger">
      <p>Save changed settings Incorrect rule settings may affect the service</p>
    </b-modal>
    <!-- 레벨 설명 모달 -->
    <b-modal title="Explain Level Coverage"  class="modal-info text-center" v-model="explain_level" ok-only no-close-on-backdrop ok-variant="success">
      <div class="text-center">
        <img src="img/waf_level.png"
          class="text-center"
          style="margin-left: auto; margin-right: auto;width: 90%;"
        >
      </div>
      <hr>
      Level 4 is detect by policy level 1 ~ 4<br>
      Level 3 is detect by policy level 1 ~ 3<br>
      Level 2 is detect by policy level 1 ~ 2<br>
      Level 1 is detect by policy level 1<br>
      <hr>
      <p>
        The higher the level, the deeper the attack is detected.
      </p>
    </b-modal>
    <!-- 모드 설명 모달 -->
    <b-modal title="Explain Mode"  class="modal-info text-center" v-model="explain_mode" ok-only no-close-on-backdrop ok-variant="success">
    <b-badge variant="warning">Notice</b-badge>
     <strong> The policy security level defaults to 1 and higher levels may affect the service </strong><br>
     <strong> * Off : Disable Web Castle Activation </strong><br>
     <strong> * DetectionOnly : Detect Only while on Activation </strong><br>
     <strong> * On : Block While On Activation </strong><br>
     <strong> * Multiplexing : Managed by a multiplexed firewall policy </strong>
    </b-modal>

    <!-- 다른 서버 적용 모달 다시 확인 -->
    <!-- <b-modal hide-footer title="Confirm for apply to policy" size="xm" v-model="apply_confirm_modal" header-bg-variant='danger'>
      Are you sure apply setting to selected agent ?
      <hr>
      <b-button block variant="danger" @click="multi_save" class="m-1">Apply</b-button>
      <b-button block variant="info" @click="apply_confirm_modal = false" class="m-1">Close</b-button>
    </b-modal> -->
    <!-- 방화벽 운영 모드 관련 안내 모달 -->
    <b-modal title="Domain Manage" class="modal-info" size="xl" v-model="explain_user_crs" no-close-on-backdrop ok-only @ok="explain_user_crs = false">
      <b-table ref="_list" striped hover small fixed class="table-responsive-sm" :items="manage && manage.policy_json && manage.policy_json.domains" :fields="domain_manage_fields" empty-text="not found">
        <template slot="domain" slot-scope="row">
          <b-form-input :disabled="('default' == row.item.domain && row.index == 0) || !row.item.temp" class="pull-right m-1" size="sm" v-model="row.item.domain"></b-form-input>
        </template>
        <template slot="status" slot-scope="row">
          <b-badge v-if="row.item.temp" variant="danger">Un Saved</b-badge>
          <b-badge v-else variant="success">used</b-badge>
          <span v-if="row.item.domain == sel_domain.domain">*</span>
        </template>
        <template slot="mode" slot-scope="row">
          <!-- {{row.item.mode}} -->
          <b-badge v-if="row.item.mode == codes.WAF_MODE_OFF.VALUE || row.item.mode == codes.WAF_MODE_OFF.TEXT" variant="secondary">Off</b-badge>
          <b-badge v-if="row.item.mode == codes.WAF_MODE_DETECTIONONLY.VALUE || row.item.mode == codes.WAF_MODE_DETECTIONONLY.TEXT" variant="warning">DetectionOnly</b-badge>
          <b-badge v-if="row.item.mode == codes.WAF_MODE_ON.VALUE || row.item.mode == codes.WAF_MODE_ON.TEXT" variant="danger">Block</b-badge>
        </template>
        <template slot="level" slot-scope="row">{{row.item.level}}</template>
        <template slot="button" slot-scope="row">
          <b-button size="sm" :disabled="row.item.temp" variant="outline-warning" @click="domain_manage_regist(row.item.domain, `${row.item.domain}.${(new Date()).getTime()}`)">Clone</b-button>
          <b-button v-if="row.item.domain != 'default'" size="sm" variant="outline-danger" @click="domain_direct_remove(row.item)">Remove!</b-button>
        </template>
      </b-table>
      <hr>
      <p>
        <span class="float-left font-weight-bold text-danger">When charging, subdomains will be charged to one domain.</span>
        <b-button class="pull-right m-1" size="sm" variant="success" @click="domain_manage_regist()">Add</b-button>
        <b-form-input class="pull-right m-1" size="sm" v-model="domain" @keyup.native.enter="domain_manage_regist()" placeholder="Domain Add Enter" style="max-width: 20rem;"></b-form-input>
      </p>
    </b-modal>
    <b-modal title="Domain Remove" class="modal-danger" v-model="explain_user_domain" no-close-on-backdrop @ok="domain_manage_remove()" header-bg-variant="danger">
      Are you sure you want to delete it?
      Deletion does not work.
    </b-modal>
    <b-modal title="Policy Remove" class="modal-danger" v-model="remove_modal" no-close-on-backdrop @ok="remove()" header-bg-variant="danger">
      Are you sure you want to delete this Multiplexing policy?
      <hr>
      When deleting, agents that used to be set to redundancy must be set individually.
    </b-modal>
  </div>
</template>

<script>

import { api, signalr } from '@/f1/service';
import RuleSelector from '@/f1/views/WebCastle/modules/Rule.Selector'
import RuleQuickSetup from '@/f1/views/WebCastle/modules/Rule.Quick.Setup'
import RuleService from '@/f1/views/WebCastle/modules/Rule.Service'
import RuleIP from '@/f1/views/WebCastle/modules/Rule.IP.i18n'
import RuleCustom from '@/f1/views/WebCastle/modules/Rule.Custom.i18n'
import _ from 'lodash'
import AgentList from '@/f1/views/WebCastle/modules/Modules.List';
import Log from '@/f1/views/WebCastle/log/Log.List';
import punycode from 'punycode'
import codes from '@/f1/codes'
import { VclFacebook } from 'vue-content-loading';
import moment from 'moment-timezone'

const default_setting = () => ({ mode: 0, level: 1 });
const default_user = () => ({
  block : [],
  detect : [],
  parameter: [],
  path: [],
  allow_ip : [],
  block_ip : [],
  custom_rule : '',
});
export default {
  props: ['is_one'],
  components: { Log, RuleSelector, AgentList, RuleQuickSetup, RuleService, RuleIP, RuleCustom, VclFacebook },
  data: () => {
    return {
      remove_modal : false,
      add : true,
      codes,
      // 빠른 설정 관련
      ico : { width: 30, height: 30, class: 'm1' },
      quick_modal : false,
      quick_setting_status : false,
      is_first : false,
      quick_setting : {
        DRUPAL : { use : true, key : [], indeterminate : false },
        WORDPRESS : { use : true, key : [], indeterminate : false },
        JAVA : { use : true, key : [], indeterminate : false },
        IIS : { use : true, key : [], indeterminate : false },
        PHP : { use : true, key : [], indeterminate : false }
      },
      policy_list : [],
      apply_all_server: [],
      apply_confirm_modal : false,
      apply_modal : false,

      sel_domain : { index : 0, domain : "default", rule : [], mode : 0, level : 1, status : true, temp : false },
      policy_default : {
        block : [],
        detect : [],
        rule : [],
        mode : 0,
        level : 1,
        parameter: [],
        url: [],
        allow_ip : [],
        block_ip : [],
        custom_rule : '',
      },
      changed_status : false,
      // 아래 변수 사용 여부 확인 필요

      explain_user_domain : false,
      domain_remove : undefined,
      policy_select : false,
      checked_policy : [],
      target_select : false,
      select_default : false,
      checkedNames : [],
      explain_level : false,
      explain_mode : false,
      detect : [],
      block : [],
      rule_confirm : false,
      agent_confirm : false,
      status_confirm : false,
      explain_user_crs : false,
      // start websocket val

      sel_rule : {},
      domain : '',
      Rule : '',
      setting : { mode : 0, level : 1 },
      // end websocket val
      signalr,
      // confirm : false, // for explain modal
      perPage: 50, // for log showing count
      currentPage: 1,
      totalRows: 50,
      tabIndex: 0,
      default_rule : {},
      user: {}, // 사용자 설정
      rule_set : {},
      manage : { url : "", policy_json : { domains : [] } },
      // end default
      policy: {},
      target_list: [],
      loading: true,
      domain_manage_fields : [
        { key : 'domain', label: 'Domain' },
        { key : 'status', label: 'Status' },
        { key : 'mode', label: 'Mode' },
        { key : 'level', label: 'Policy Security Level' },
        { key: 'button', label: 'Action' },
      ],
      fields : [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
        { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 15%' },
        { key: 'remote_addr', label: 'Attacker', sortable: false, thStyle: 'width: 5%' },
        { key: 'severity', label: 'Risk', sortable: false, thStyle: 'width: 10%' },
        { key: 'message', label: 'Message', sortable: false },
        { key: 'ruleid', label: 'RuleID', sortable: false },
        { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 15%' },
      ],
      th : undefined
    }
  },
  computed: {
    startRow () { return this.totalRows - (this.currentPage - 1) * this.perPage; }
  },
  methods: {
    // 퀵 설정 저장 함수
    save_default(policy) {
      try {
        this.sel_domain =  Object.assign({}, this.sel_domain, policy)
        this.setting.level = policy.level
        this.user = Object.assign({}, this.user,  { block_ip : policy.block_ip, allow_ip : policy.allow_ip, path : policy.path })
        this.setting.mode = policy.mode

        // 룰 저장 함수
        this.policy_rule(policy.rule)

        // 빠른 설정 끝
        this.quick_setting_status = false
        this.manage.updated_at = moment().format('YYYY MM DD HH:mm:ss')

      } catch (e) { console.error(e) }
    },
    domain_direct_remove(item) {
      try {
        this.domain_remove = item.domain
        // 임시 도메인이면 바로 지금
        if(item.temp) { return this.domain_manage_remove(item.domain) }
        // 그게 아니면 지우는 모달 토글
        this.explain_user_domain = true
      } catch (e) { console.error(e) }
    },
    // 다른 서버 적용 함수 시작
    async multi_save() { // 설정 저장
      try{

        let manage = Object.assign({}, this.manage, {
          agent_list : this.apply_all_server.map(r => r.id)
        })

        let rs = await api.webcastle.WebCastle_Call('manage', 'update', manage);
        if(rs.error) { return this.$toastr.e("update failed") }

        this.manage.count_agent = rs.body.count_agent;

        this.$toastr.s('Apply to agents.');
        this.$emit('refresh');
        this.$refs._wc_agent_list ? this.$refs._wc_agent_list.refresh() : ''

        this.apply_confirm_modal = false
        this.apply_modal = false
      } catch(e) { this.catch_msg(e) }
    },
    multi_remove(index) { this.apply_all_server.length < 2 ? this.apply_all_server = [] : this.apply_all_server.splice(index, 1) },
    multi_one(item) {
      if(item) {
        if(!item) { return 'no have a data' }
        // console.log(item, this.apply_all_server)
        if(item.is_del) {
          this.apply_all_server = this.apply_all_server.map(r => { if (r && r.id != item.id) { return r } }).filter( r => r != null)
        } else {
          this.apply_all_server.push(item)
        }
      }
     },
    multi_all(items) { (items || []).map(r => { r && _.filter(this.apply_all_server, { nickname : r.nickname }).length < 1 ? this.apply_all_server.push(r) : '' }) },
    multi_clear() { this.apply_all_server = [], console.log("clear") },
    catch_msg(e) { console.log(e), this.$toastr.e(!e.data ? e : (e.data.message ? e.data.message : e.statusText)) },
    // 다른 서버 적용 함수 끝
    toggle_policy($value, key) {
      // 특정 룰을 사용하지 않음
      // console.debug("is index", key)
      let rindex = _.findIndex(this.rule_set.rule, x => x.key == key);
      rindex > -1 ? this.$refs.RuleSelector.$children.forEach(x => x.policy_toggle(rindex, -1, $value)) : ''
    },
    filterBlank(x) { return x ? _.uniq(_.map(x.split('\n'), r => r.trim())) : [] },
    async policy_rule(rule) {
      try {
        // 레벨 alc
        // this.manage.level = this.setting.level
        // this.manage.mode = this.setting.mode

        // 임시 룰 삭제, 저장하지 않음
        for(var i = 0; i < this.manage.policy_json.domains.length; i++){
          if(this.manage.policy_json.domains[i].temp){
            delete this.manage.policy_json.domains[i].temp;
          }
        }
        let index = _.findIndex(this.manage.policy_json.domains, {domain : this.sel_domain.domain})
        let domain = this.manage.policy_json.domains[index];

        // console.log(this.setting, "setting")
        domain.mode = this.setting.mode;
        domain.level = this.setting.level;
        domain.rule = _.uniq(rule);
        // console.debug('test', domain.mode, codes.WAF_MODE_OFF.VALUE)

        this.user.custom_rule = this.filterBlank(this.user.custom_rule).join('\n');
        domain.custom_rule = this.user.custom_rule ? this.user.custom_rule : '';

        this.user.block_ip = this.filterBlank(this.user.block_ip)
        domain.block_ip = this.user.block_ip && this.user.block_ip.length ? this.user.block_ip : [];
        this.user.block_ip = (this.user.block_ip || []).join('\n')

        this.user.allow_ip = this.filterBlank(this.user.allow_ip)
        domain.allow_ip = this.user.allow_ip && this.user.allow_ip.length ? this.user.allow_ip : [];
        this.user.allow_ip = (this.user.allow_ip || []).join('\n')

        this.user.path = this.filterBlank(this.user.path)
        domain.path = this.user.path && this.user.path.length ? this.user.path : [];
        this.user.path = (this.user.path || []).join('\n')

        this.user.parameter = this.filterBlank(this.user.parameter);
        domain.parameter = this.user.parameter && this.user.parameter.length ? this.user.parameter : [];
        this.user.parameter = (this.user.parameter || []).join('\n')

        // 미사용중인 룰 필터링
        console.log(domain.mode, 'domain.mode', domain.mode == codes.WAF_MODE_ON.VALUE)
        if(domain.mode == codes.WAF_MODE_ON.VALUE) {
          domain.block = this.sel_domain.block && this.sel_domain.block.length ? _.filter(this.sel_domain.block, r => _.indexOf(domain.rule, r) < 0) : [];
          this.sel_domain.block = domain.block
          domain.detect = this.sel_domain.detect && this.sel_domain.detect.length ?  _.filter(this.sel_domain.detect, r => _.indexOf(domain.rule, r) < 0) : [];
          this.sel_domain.detect = domain.detect
        } else {
          // off or detectionOnly
          domain.detect = domain.block = []
        }

        let mode = domain.mode = domain.mode == codes.WAF_MODE_ON.VALUE ? codes.WAF_MODE_ON.TEXT : (domain.mode == codes.WAF_MODE_DETECTIONONLY.VALUE ? codes.WAF_MODE_DETECTIONONLY.TEXT : codes.WAF_MODE_OFF.TEXT)
        this.manage.policy_json.domains[index] = Object.assign({}, domain, { mode : mode })
        if(!this.changed_status && domain.mode != codes.WAF_MODE_OFF.VALUE) {
          // OFF 가 아니라면 사용하기 위해 On
          this.manage.policy_json.status = true
          this.setting.status = this.manage.policy_json.status
        }

        // console.log(this.manage.policy_json.domains[index], 'final')
        // return

        this.manage.policy = JSON.stringify(this.manage.policy_json);
        this.manage.agent_list = _.map(this.apply_all_server, x => x.id)

        let rs = await api.webcastle.WebCastle_Call('manage', this.add ? 'insert' : 'update', this.manage);
        if(rs.error) { return this.$toastr.e("update failed") }
        let id = rs.body.id

        this.manage.count_domain = rs.body.count_domain;

        this.$toastr.s("Saved successfully");
        this.changed_status = false

        // 신규 추가일 경우 라우터 변경
        this.add ? this.$router.push({ name: 'webcastle_multiplexing', params: { id: id }}) : ''
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'Save failed'); }
    },
    async status_save(a){
      try{
        this.manage.policy_json.status = a;
        this.manage.policy = JSON.stringify(this.manage.policy_json);
        let status_data = this.manage;
        delete status_data.policy_json.id
        delete status_data.policy_json.body

        let rs = await api.webcastle.WebCastle_Call('manage', 'update', status_data)
        if(rs.error) { return this.$toastr.e("update failed") }
        this.$toastr.s("Saved successfully")
        this.changed_status = true
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'Save failed'); }
    },
    async save() {
      // 위의 함수에서 Update 날림.
      try {
        this.$refs.RuleSelector.$children.forEach(r => r.toss_rule())
        // this.$refs.RuleSelector.toss_rule();

        this.manage.mode = this.setting.mode
        let update_data = this.manage;
        delete update_data.policy_json.id
        delete update_data.policy_json.body

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, 'Save failed'); }
    },
    async domain_manage_remove(domain = undefined) {
      // Domain remove
      try{
        if(domain) { this.domain_remove = domain }

        // 이전 저장된 데이터는 삭제 및 저장, 새로운 도메인은 삭제
        if(_.filter(this.manage.policy_json.domains, r => r.domain == this.domain_remove && !r.temp).length > 0) {
          console.log("remove & save")
          this.save();
        }

        // 삭제된 도메인 필터
        this.manage.policy_json.domains = _.filter(this.manage.policy_json.domains, r => r.domain != this.domain_remove)
        this.$refs._list ? this.$refs._list.refresh() : ''

        // 최근 추가된 도메인으로 설정함
        this.sel_domain = Object.assign({}, this.sel_domain, this.policy_default, this.manage.policy_json.domains[this.manage.policy_json.domains.length - 1])
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 8'); }
    },
    async domain_manage_regist(origin_domain=undefined, domain = undefined) {
      // Domain Add
      try {
        if(domain) { this.domain = domain }
        if(!this.domain) { return this.$toastr.w("Typing plz domain on server", "required!") }

        const rs = await api.webcastle.WebCastle({target : 'agent', cmd : 'domain.limit', body : new Date().getTime()})
        if(rs.error) { return this.$toastr.e("can't verify license") }
        // 라이선스 확인
        if(rs.body < this.manage.policy_json.domains.length) { return this.$toastr.e("Number of domains exceeded! Please upgrade your license!")}
        // 중복 확인
        if(_.filter(this.manage.policy_json.domains, d => d.domain == this.domain).length > 0) { return this.$toastr.e("duplicate!!"); }
        // 한글 도메인 등록
        if(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(this.domain)){ this.domain = punycode.toASCII(this.domain) }

        // clone 때문에 그럼
        // console.log(this.policy_default, default_user())
        let new_domain = origin_domain != undefined ?
          Object.assign({}, this.policy_default, this.sel_domain, this.user, { domain : this.domain }, { temp : true }) :
            Object.assign({}, this.policy_default, default_user(), { domain : this.domain }, { temp : true })

        // 모드 강제 설졍
        if(origin_domain != undefined) {
          new_domain.mode = this.setting.mode == codes.WAF_MODE_ON.VALUE ?
          codes.WAF_MODE_ON.TEXT :
            (this.setting.mode == codes.WAF_MODE_DETECTIONONLY.VALUE ?
              codes.WAF_MODE_DETECTIONONLY.TEXT :
                codes.WAF_MODE_OFF.TEXT)
        } else {
          new_domain.mode = origin_domain === undefined && this.policy_default.mode == codes.WAF_MODE_ON.VALUE ?
          codes.WAF_MODE_ON.TEXT :
            (this.policy_default.mode == codes.WAF_MODE_DETECTIONONLY.VALUE ?
              codes.WAF_MODE_DETECTIONONLY.TEXT :
                codes.WAF_MODE_OFF.TEXT)
        }

        // 방화벽 룰
        this.manage.policy_json.domains.push(Object.assign({}, new_domain));
        this.domain = ''
        // 설정 초기화
        this.setting = origin_domain != undefined ?
          Object.assign({}, this.setting, { status : this.setting.status }) :
            Object.assign({}, default_setting(), { status : this.setting.status })
        // 새로운 도메인 적용
        this.change_domain(new_domain.domain)
        // 새로고침
        this.$refs._list ? this.$refs._list.refresh() : ''
        // 여기까지 도메인 임시 저장
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 8'); }
    },
    refresh() {
      this.$forceUpdate();
      this.$refs && this.$refs._list ? this.$refs._list.refresh() : ''
    },
    change_domain(domain){
      try {
        console.log("refresh to ", domain)
        if(!domain) { return this.$toastr.e("no have seleted domain") }
        this.sel_domain = Object.assign({}, _.find(this.manage.policy_json.domains, { domain : domain }));
        this.sel_domain.mode = this.sel_domain.mode == codes.WAF_MODE_ON.TEXT ? 2 : (this.sel_domain.mode == codes.WAF_MODE_DETECTIONONLY.TEXT ? 1 : 0)
        this.setting.mode = this.sel_domain.mode
        this.setting.level = this.sel_domain.level
        this.$refs.RuleSelector.$children.forEach(x => x.parser_setting())
        // this.$refs.RuleSelector.parser_setting()
      } catch (e) { console.log(e); this.$toastr.e("load error #1") }
    },
    // initialize
    async get(reload=undefined){
      try {
        let id = this.$route.params.id
        // 에이전트 로딩
        if(reload != false) {

          if(id != 'add') {
            this.add = false
            let rs = await api.webcastle.WebCastle({ target : 'manage', cmd: 'detail', body: { id : id }})
            if(rs.error) { return this.$toastr.e("load failed agent") }
            this.manage = Object.assign({}, rs.body, { policy_json : JSON.parse(rs.body.policy) });
            this.apply_all_server = []
            this.apply_all_server = this.manage.agent_list_data
            this.default_rule = JSON.parse(this.manage.crs.crs_json);
            this.rule_set = JSON.parse(this.manage.crs.crs_json);


            // 기본 정책 로딩
            // let rs_crs = await api.webcastle.WebCastle({ target : 'policy', cmd : 'detail', body : { id : this.manage.crs_id } });
            // if(rs_crs.error) { return this.$toastr.e("load failed policy") }
            // this.default_rule = JSON.parse(rs_crs.body.crs_json);
            // this.rule_set = JSON.parse(rs_crs.body.crs_json)
            // return console.log("is not saved", this.sel_domain.domain)
          } else {

            // // 기본 정책 로딩
            // let rs_crs = await api.webcastle.WebCastle({ target : 'policy', cmd : 'detail', body : { id : this.manage.crs_id } });
            // if(rs_crs.error) { return this.$toastr.e("load failed policy") }
            // this.default_rule = JSON.parse(rs_crs.body.crs_json);
            // this.rule_set = JSON.parse(rs_crs.body.crs_json)

            // 없으므로 처음 정책 템플릿(default 포함)이 정책이 된다
            let rs_template = await api.webcastle.WebCastle({ target : 'policy', cmd: 'template'})
            if(rs_template.error) { return this.$toastr.e("load failed template") }
            this.manage = Object.assign({}, rs_template.body, { policy_json : rs_template.body });
            this.apply_all_server = []

            // 최신 정책 가져와서 만들기
            let rs_crs = await api.webcastle.WebCastle({ target : 'policy', cmd: 'latest', body: { ts : new Date().getTime() }})
            if(rs_crs.error) { return this.$toastr.e("load failed agent") }

            console.log(rs_crs.body.crs_json, 'rs_crs.body.crs_json')

            this.manage = Object.assign({}, this.manage, {
              crs_id : rs_crs.body.id,
              version : rs_crs.body.version,
              default_rule : JSON.parse(rs_crs.body.crs_json) // 기본 정책 할당
            });
            this.default_rule = JSON.parse(rs_crs.body.crs_json);
            this.rule_set = JSON.parse(rs_crs.body.crs_json)
          }

        }

        // 에이전트 정책 로딩, 처음 기본값 도메인은 default
        let index = _.findIndex(this.manage.policy_json.domains, { domain : this.sel_domain.domain } )
        let policy = Object.assign({}, this.policy_default, this.manage.policy_json.domains[index])
        console.debug('policy.mode', policy.mode)

        // default 도메인의 기본 설정
        policy.mode = policy.mode == codes.WAF_MODE_ON.TEXT ? 2 : (policy.mode == codes.WAF_MODE_DETECTIONONLY.TEXT ? 1 : 0)

        this.setting = _.pick(policy, ['mode', 'level']);
        this.setting.status = this.manage.policy_json.status; // global option

        this.user = default_user();
        try {
          this.user.custom_rule = policy.custom_rule ? policy.custom_rule : '';
          this.user.block_ip = (policy.block_ip || []).join('\n');
          this.user.allow_ip = (policy.allow_ip || []).join('\n');
          this.user.path = (policy.path || []).join('\n');
          this.user.parameter = (policy.parameter || []).join('/');
        } catch (e) { console.error("load failed", e); this.user = default_user(); }

        // 룰 적용
        this.sel_domain = Object.assign({}, this.sel_domain, policy)

        if(this.manage.updated_at == this.manage.created_at) { this.quick_setting_status = true; this.is_first = true }

        this.loading = false

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 1'); }
    },
    async remove() {
      try{
        let rs = await api.webcastle.WebCastle_Call('manage', 'delete', Object.assign({}, { id : this.manage.id, agent_list : this.apply_all_server.map(r => r.id) }))
        if(rs.error) { return this.$toastr.e("update failed") }
        this.$toastr.s("Deleted successfully")
        this.$emit('refresh')
        this.$refs._wc_agent_list ? this.$refs._wc_agent_list.refresh() : ''
        this.$router.push({ name : 'webcastle_multiplexing' })
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, 'Save failed'); }
    },
  },
  watch: { '$route' (to, from) { console.log("from ", from); this.get(to.params.id); },
  },
  created() {
    console.log('modules.detail.vue', 'created');
    return this.get()

  },
  destroyed() {
    if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
    console.log('modules.detail.vue', 'destroyed');
  },
  mounted() {
    console.log('modules.detail.vue', 'mounted');
    // this.policy_default = Object.assign({}, default_setting(), default_user())
    // 개선해야 하는 부분, 한번에 요청 방지
    if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
    // if(location.hostname == 'localhost') {
    //   this.quick_setting_status = true
    // }
  },
}
</script>
